import { LookupDataService } from "../services/lookup-data/lookup-data.service";
import { store } from "../store/store";

export const SET_LOOKUP_DATA = 'SET_LOOKUP_DATA';

export const fetchLookupData = async () => {
    const res = await LookupDataService.getList();
    store.dispatch(setLookupData(res));
}

export const setLookupData = (data: any) => {
    return {
        type: SET_LOOKUP_DATA,
        data
    }
}
